import { QuickCreationNav } from '@fc-core/components/header/quick-creation/quick-creation.nav';

export const quickCreationNavStructure: QuickCreationNav[] = [
  {
    name: 'Vehicles',
    icon: 'icon-vehicles-outline',
    children: [
      {
        name: 'Create Vehicle',
        path: [
          'vehicles/main/vehicles/',
          { outlets: { modal: ['add-vehicle'] } },
        ],
        icon: 'icon-vehicles-outline',
        type: 'vehicles',
      },
      {
        name: 'Create Vehicle Group',
        path: [
          'vehicles/main/vehicle-groups',
          { outlets: { modal: ['add-group'] } },
        ],
        icon: 'icon-vehicles-group',
        type: 'vehicle-groups',
      },
    ],
  },
  {
    name: 'Locations',
    icon: 'icon-location-outline',
    featureKey: 'locations',
    children: [
      {
        name: 'Create Location',
        path: ['locations/main/location-list', 'new'],
        icon: 'icon-location-outline',
        type: 'locations',
      },
      {
        name: 'Create Location Type',
        routerParams: {
          routerLink: ['/locations', 'settings', 'types'],
          queryParams: { dialog: 'create' },
        },
        icon: 'icon-list-bulleted',
        type: 'location-types',
      },
      {
        name: 'Create Location Group',
        routerParams: {
          routerLink: ['/locations', 'settings', 'groups'],
          queryParams: { dialog: 'create' },
        },
        icon: 'icon-vehicles-group',
        type: 'location-groups',
      },
    ],
  },
  {
    name: 'Employees',
    icon: 'icon-group-outline',
    children: [
      {
        name: 'Create Employee',
        path: ['/users', 'main', 'users', { outlets: { modal: ['new'] } }],
        icon: 'icon-group-outline',
        type: 'users',
      },
      {
        name: 'Create Employee Group',
        path: [
          '/users',
          'main',
          'user-groups',
          { outlets: { modal: ['new'] } },
        ],
        icon: 'icon-user-group',
        type: 'user-groups',
      },
    ],
  },
  {
    name: 'Assets',
    icon: 'icon-tool-bold',
    featureKey: 'assets',
    children: [
      {
        name: 'Create Asset',
        icon: 'icon-tool-bold',
        routerParams: {
          routerLink: ['/fleet-assets'],
          queryParams: { dialog: 'create' },
        },
        type: 'assets',
      },
      {
        name: 'Create Asset Type',
        icon: 'icon-list-bulleted',
        routerParams: {
          routerLink: ['/fleet-assets', 'types'],
          queryParams: { dialog: 'create' },
        },
        type: 'asset-types',
      },
      {
        name: 'Create Asset Group',
        icon: 'icon-vehicles-group',
        routerParams: {
          routerLink: ['/fleet-assets', 'groups'],
          queryParams: { dialog: 'create' },
        },
        type: 'asset-groups',
      },
    ],
  },
  {
    name: 'CRM',
    icon: 'icon-crm-outline',
    featureKey: 'crm',
    children: [
      {
        name: 'Create Company',
        icon: 'icon-crm-outline',
        routerParams: {
          routerLink: ['/crm', 'main', 'companies'],
          queryParams: { dialog: 'company' },
        },
        type: 'companies',
      },
      {
        name: 'Create Contact',
        icon: 'icon-person',
        routerParams: {
          routerLink: ['/crm', 'main', 'contacts'],
          queryParams: { dialog: 'contact' },
        },
        type: 'contacts',
      },
    ],
  },
  {
    name: 'Live Share',
    icon: 'icon-share',
    children: [
      {
        name: 'Create Live Share',
        icon: 'icon-share',
        routerParams: {
          routerLink: ['/shared'],
          queryParams: { dialog: 'create' },
        },
        type: 'live-share',
      },
    ],
  },
  {
    name: 'Forms',
    icon: 'icon-inspections-outline',
    featureKey: 'forms',
    children: [
      {
        name: 'Create Form',
        icon: 'icon-inspections-outline',
        routerParams: {
          routerLink: ['/forms', 'forms-list'],
          queryParams: { dialog: 'create' },
        },
        type: 'forms',
      },
    ],
  },
  {
    name: 'Documents',
    icon: 'icon-document-outline',
    featureKey: 'drive_documents',
    children: [
      {
        name: 'Upload Document',
        icon: 'icon-cloud-upload',
        routerParams: {
          routerLink: ['/documents'],
          queryParams: { dialog: 'upload' },
        },
        type: 'documents',
      },
    ],
  },
  {
    name: 'Events',
    icon: 'icon-events-outline',
    featureKey: 'events',
    children: [
      {
        name: 'Create Event',
        icon: 'icon-events-outline',
        path: ['events', { outlets: { modal: ['select-template'] } }],
        type: 'events',
      },
    ],
  },
  {
    name: 'Tasks',
    icon: 'icon-tasks-outline',
    featureKey: 'project_tasks_management',
    children: [
      {
        name: 'Create Task',
        icon: 'icon-tasks-outline',
        routerParams: {
          routerLink: ['/tasks'],
          queryParams: {
            dialog: 'create',
          },
        },
        type: 'tasks',
      },
    ],
  },
  {
    name: 'Projects',
    icon: 'icon-project',
    featureKey: 'projects',
    desktopOnly: true,
    children: [
      {
        name: 'Create Project',
        icon: 'icon-project',
        routerParams: {
          routerLink: ['/projects'],
          queryParams: { dialog: 'create' },
        },
        type: 'projects',
      },
    ],
  },
];
